module.exports = __webpack_public_path__ + "static/media/13.32ecd071.jpeg";